import http from '../libs/http'
import store from './index'

let getters = {
	getRoleTypes: state => {
			let types = state.constants.role_types;
			let i = 0;
			let roleTypes = [];

			for (var key in types) {
					roleTypes[i] = {'name': types[key].name, 'type': types[key].type};
					i++;
			}
      return roleTypes
	},
	getUserRoles: state => {
		let croles = state.user.user.roles;
		let i = 0;
		let roles = [];

		for (var key in croles) {
				roles[i] = {
				'role_id': 			croles[key].role_id,
				'role_name': 		croles[key].role_name + (croles[key].company_name ? ', '+croles[key].company_name : ''),
				'role_type': 		croles[key].role_type,
				'company_name': croles[key].company_name,
				'company_id': 	croles[key].company_id,
				'permissions':  croles[key].permissions,
				};
			i++;
		}
		return roles;
	},
	getPermissions: state => {
		let permissions = [];
		var is_platform_admin = false;

		if (typeof state.userSelectedRole != 'undefined') {
				if (typeof state.userSelectedRole.permissions != 'undefined' && !state.userSelectedRole.company_id) {
						for (var key in state.userSelectedRole.permissions) {
								if (key == 'platform' && state.userSelectedRole.permissions[key].update == 1) {
										is_platform_admin = true;
								}
						}
				}
		}

		let i = 0;
		if (typeof(state.constants.permissions) != 'undefined') {
			for (var key in state.constants.permissions) {
					if (!is_platform_admin) {
						if (state.constants.permissions[key].code != 'platform') {
							permissions[i] = state.constants.permissions[key];
							i++;
						}
					} else {
						permissions[i] = state.constants.permissions[key];
						i++;
					}
			}
		}

		return permissions;
	},

	getPriceTypes: state => {
		return state.constants.price_types;
	},

	getCalculationTypes: state => {
		return state.constants.project_calculation_types;
	},

	getChangeOrderStatuses: state => {
		return state.constants.change_order_statuses;
	},

	getTaskStatuses: state => {
		return state.constants.task_manager_statuses;
	},

	getTaskUrgent: state => {
		return state.constants.task_manager_urgent;
	},

	getTaskImportant: state => {
		return state.constants.task_manager_important;
	},

	getChargingStatuses: state => {
		return state.constants.charging_statuses;
	},

	getPunchlistProgress: state => {
		return state.constants.punchlist_progress;
	},

	getMeasureUnits: state => {
		return state.constants.measure_units;
	},

	getCategories: state => {
		return state.constants.punchlist_categories;
	},

	getSpoolStatus: state => {
		return state.constants.spool_status;
	},

	getProjectSettings: state => {
		return state.constants.project_setting;
	},

	getProgressSettings: state => {
		return state.constants.progress_setting_keys;
	},
	getProjectMandatorySettings: state => {
		return state.constants.project_mandatory_setting;
	},
	getDefaultProjectSettings: state => {
		return state.constants.project_default_setting;
	},

	getCurrencies: state => {
		return state.constants.billing_currencies;
	},

	getMonths: state => {
		return state.constants.months;
	},

	getBillingStatuses: state => {
		return state.constants.billing_status;
	},

	getStockStatuses: state => {
		return state.constants.stock_status;
	},

	getDrawingPriority: state => {
		return state.constants.drawing_priority;
	},

	getHeatTracing: state => {
		return state.constants.heat_tracing;
	},

	getIsometricConsideration: state => {
		return state.constants.isometric_consideration;
	},

	getIsometricCalculationMethods: state => {
		return state.constants.isometric_calculation_methods;
	},

	getTieInTypes: state => {
		return state.constants.tie_in_types;
	},

	getBillingVat: state => {
		return state.constants.billing_vat;
	},

	getTicketStatuses: state => {
		return state.constants.ticket_status;
	},

	getTicketPriorities: state => {
		return state.constants.ticket_priority;
	},

	getTicketSubmittedFor: state => {
		return state.constants.submitted_for_constants;
	},

	getWelderStatuses: state => {
		return state.constants.welder_status;
	},

	getTieInProgressStatuses: state => {
		return state.constants.tie_in_progress_status;
	},

	getProjectStatuses: state => {
		return state.constants.project_status;
	},

	getWeldPlaces: state => {
		return state.constants.weld_place;
	},

	getCurrentWeldSpecialColumns: state => {
		return state.constants.current_weld_special_columns;
	},

	getScaffoldingStatuses: state => {
		return state.constants.scaffolding_status;
	},

	getTypeOfItems: state => {
		return state.constants.type_of_item;
	},

	getProjectConditions: state => {
		return state.constants.project_conditions;
	},

	getProjectContractTypes: state => {
		return state.constants.project_contract_types;
	},

	getProjectTypes: state => {
		return state.constants.project_types;
	},

	getDefaultDisciplines: state => {
		return state.constants.disciplines_default;
	},

	getPartStandard: state => {
		return state.constants.part_standard;
	},

	getBlindRatings: state => {
		return state.constants.blind_ratings;
	},

	getLanguages: state => {
			let i = 0;
			let languages = [];
			if (typeof (state.constants.languages) != 'undefined') {
				let types = state.constants.languages;
				for (var key in types) {
						languages[i] = {'name': types[key].name, 'code': types[key].code, 'img': types[key].img};
						i++;
				}
			}

			return languages;
	},

	getUserAvatar: state => {
		if (typeof(state.user.user) != 'undefined') {
			if (typeof(state.user.user.avatar) != 'undefined') {
				if (state.user.user.avatar.length > 0) {
					return 'data:image/jpg;base64,' + state.user.user.avatar;
				} else {
					return require('@/assets/img/no-avatar.png');
				}
			} else {
				return require('@/assets/img/no-avatar.png');
			}
		} else {
			return require('@/assets/img/no-avatar.png');
		}
	},

	getUserSignature: state => {
		if (typeof(state.user.user) != 'undefined') {
			if (typeof(state.user.user.user_signature) != 'undefined') {
				return state.user.user.user_signature;
			}
		}

		return null;
	},

	getUserCompanyAvatar: state => {
		if (typeof(state.userSelectedRole.company_avatar) != 'undefined') {
			if (state.userSelectedRole.company_avatar.length > 0) {
				return 'data:image/jpg;base64,' + state.userSelectedRole.company_avatar;
			} else {
				return require('@/assets/img/capslock.png');
			}
		} else {
			return require('@/assets/img/capslock.png');
		}
	},

	getUserCompanies: state => {
		let userCompanies = [];

		//@todo from actions

		return userCompanies;
	},
	getMenuProjects: state => {
		return state.menu_projects;
	},

	hasPermission: (state) => (permissions, rights) => {
			let allowed = false;

			if (permissions.length == 0) return true;//this requires at least to be logged in

			let user_permissions = [];
			let user_permissions_rights = {};
			// console.log(state.userSelectedRole);
			if (state.userSelectedRole) {
					if (state.userSelectedRole.permissions) {
							for (var key in state.userSelectedRole.permissions) {
									user_permissions.push(key);
									user_permissions_rights[key] = state.userSelectedRole.permissions[key];
							}
					}
			}

			if (rights && rights.length > 0) {
				permissions.forEach(perm => {
						if (user_permissions.indexOf(perm) !== -1) {
							let allow_count = 0;
							rights.forEach(right => {
								if (user_permissions_rights[perm][right]) {
									allow_count++;
								}
							});
							if (allow_count == rights.length) allowed = true;
						}
				});
			} else {
				if (permissions.some(permission => user_permissions.indexOf(permission) !== -1)) {
					allowed = true;
				}
			}

			return allowed;
	}
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js